import { useBootstrapSelector } from '../../redux/selectorHooks';
import { assertNotNil } from '../types';
import usePermission from '../hooks/permissionHooks/usePermission';
import { PermissionKey } from '../apollo/graphqlSchema';

const useShowAdminSettings = () => {
  const permissionConfig = useBootstrapSelector('permissionConfig');
  assertNotNil(permissionConfig);
  const { checkIsPermitted } = usePermission();
  const isPermittedForAdmin = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.AdminRead],
  });

  return isPermittedForAdmin && permissionConfig.enablePermissionControl;
};

export default useShowAdminSettings;
